/*global define, $*/
define('core/directives/dnaModalDirective',['angular'], function (angular) {
    'use strict';
    angular.module('dnaApp').directive('dnaModal', ['$timeout', function ($timeout) {
        // var origWidth = 0;
        return {
            restrict: 'A',
            scope: {
                dnaModal: '=',
                dnaModalTitle: '@',
                dnaModalOpen: '&',
                dnaModalClose: '&',
                dnaModalWidth: '@',
                dnaModalBkgColor: '@',
                dnaModalClass: '@'
            },
            transclude: true,
            template: '<section class="modal" ng-transclude></section>',
            link: function (scope, element, attrs) {

                // Watch the modal expression to know when to show it.
                scope.$watch('dnaModal', function (show) {
                    if (show) {
                        // Check for old modal left hanging from a previous controller load.
                        var isTouch = $('html').hasClass('touch');
                        var oldModal = $('#modalContents .modal');
                        var $mainElem = element.children().first();

                        if (oldModal.length > 0) {
                            oldModal.each(function() {
                                if ($(this).attr('id') === $mainElem.attr('id')) {
                                    $(this).remove();
                                }
                            });
                        }

                        // Add placeholder for original modal content
                        $mainElem.before('<span id="dnaModalContentPlaceholder"/>');
                        $mainElem.modal({
                            width: scope.dnaModalWidth,
                            title: scope.dnaModalTitle,
                            onOpen: function () {
                                if (attrs.dnaModalFocus) {
                                    $timeout(function () {
                                        $mainElem.find(attrs.dnaModalFocus).focus();
                                    }, 50);
                                }

                                // Override the modal bkg color
                                if (scope.dnaModalBkgColor) {
                                    if (scope.dnaModalBkgColor === 'normal') {
                                        scope.dnaModalBkgColor = '#f8f7f3';
                                    }
                                    $('#modalContents').css('background-color', scope.dnaModalBkgColor);
                                }

                                // Allows for on open function
                                if (scope.dnaModalOpen) {
                                    $timeout(function() {
                                        scope.dnaModalOpen();
                                    });
                                }
                                // Remove header if none
                                if (!scope.dnaModalTitle) {
                                    $('#modalHeader').remove();
                                    if ($mainElem.find('.modalHeader').length > 0) {
                                        $('#modalContents').addClass('modalHasTitle');
                                    }
                                }
                                // Add class
                                $('#modalContents').addClass(scope.dnaModalClass);
                                // Fix for iPad bug
                                if (isTouch && $('#modalContents').outerHeight() <= 0) {
                                    $('html').removeClass('touch').addClass('noTouch');
                                    $.modal.center();
                                }
                                scope.$broadcast('dnaModalOpen');
                            },
                            onClose: function () {
                                // Make sure the expression is reset to false if the user clicks the close button provided by the FED modal.
                                if (scope.dnaModal) {
                                    $timeout(function() {
                                        scope.$apply(function() {
                                            scope.dnaModal = false;
                                        });
                                    });
                                }
                                // Allows for on close function
                                if (scope.dnaModalClose) {
                                    $timeout(function() {
                                        scope.dnaModalClose();
                                    });
                                }
                                // Remove the modal bkg color override
                                if (scope.dnaModalBkgColor) {
                                    $('#modalContents').css('background-color', '');
                                }
                                // Replace header
                                if (!scope.dnaModalTitle) {
                                    $('#modalContents').prepend('<h4 id="modalHeader"></h4>');
                                }

                                // Remove the modal bkg color override
                                if (scope.dnaModalBkgColor) {
                                    $('#modalContents').css('background-color', '');
                                }
                                // Remove class
                                $('#modalContents').removeClass(scope.dnaModalClass);
                                // Fix for iPad bug
                                if (isTouch) {
                                    $('html').removeClass('noTouch').addClass('touch');
                                }
                                scope.$broadcast('dnaModalClose');
                                // Return modal content to its original place in the DOM
                                $('#dnaModalContentPlaceholder').after($mainElem);
                                $('#dnaModalContentPlaceholder').remove();
                            }
                        });
                    }
                });

                scope.$watch('dnaModalTitle', function(newTitle) {
                    if ($.modal && scope.dnaModal && $.modal.title && typeof $.modal.title === 'function') {

                        $.modal.title(newTitle);
                    }
                });
                // Watch the background color (for compatability with stackableHelpDirective)
                scope.$watch('dnaModalBkgColor', function(newBgColor, oldBgColor) {
                    if (newBgColor) {
                        $('#modalContents').css('background-color', newBgColor);
                    } else {
                        $('#modalContents').css('background-color', '');
                    }
                });
            }
        };
    }]);
});

